import React, { useEffect, useRef } from 'react';
import createGlobe from 'cobe';

const Globe = ({ className = '' }) => {
  const canvasRef = useRef();
  const globeRef = useRef();

  useEffect(() => {
    let phi = 0;

    if (!canvasRef.current) return;

    const globe = createGlobe(canvasRef.current, {
      devicePixelRatio: 2,
      width: 2000,
      height: 2000,
      phi: 0,
      theta: 0.1,
      dark: 1,
      diffuse: 2,
      scale: 1.05,
      mapSamples: 24000,
      mapBrightness: 10,
      baseColor: [0.12, 0.2, 0.3],
      markerColor: [0.18, 0.8, 1],
      glowColor: [0.3, 0.7, 0.95],
      offset: [0, 0],
      markers: [
        { location: [17.38405, 78.45636], size: 0.07 },
      ],
      onRender: (state) => {
        // Called on every animation frame.
        state.phi = phi;
        phi += 0.002;
      }
    });

    globeRef.current = globe;

    return () => {
      globe.destroy();
    };
  }, []);

  return (
    <div 
      className={`globe-container ${className}`}
      style={{ 
        width: '100%', 
        maxWidth: '1000px',
        aspectRatio: '1',
        margin: '0 auto',
        position: 'relative',
      }}>
      <canvas
        id="cobe"
        ref={canvasRef}
        style={{
          width: '100%',
          height: '100%',
          contain: 'layout paint size',
          opacity: 1,
          transition: 'opacity 1s ease',
          background: 'transparent',
        }}
        width={1600}
        height={1600}
      />
    </div>
  );
};

export default Globe;
